export default __webpack_public_path__ + "static/media/logo_white.95d2ecf9.png";